// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-message[data-v-7708e2f5]{padding:5.5rem 3rem}.error-message p[data-v-7708e2f5]{color:#666;font-size:1.125rem;text-align:center;margin-bottom:0}", ""]);
// Exports
module.exports = exports;
